import { SHA256 } from "crypto-js";
import forge from "node-forge";

const ALPAS_PUBLIC_KEY_BODY =
  "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA5X+Q2bJ9XIewtQKaKEExfkO0yvYZoijtHYHOnv/xplHv3smiaQP8eEVVWoN2Xya5faNxlAJs7UBiMYQLJ7u3siusCH/gfKY3Tv5FcbUZ8Jvja9VYUc7HrRDtNbW6UEG++0XFTnCqz/UTKdtxAw1sagNUQjH43wvuY86fIfFVW+QjExkroDNCS0ZEur022kkgJEWXvZxK3mI2eMPx9XM9nOnE1MN0h3B1ublHTiEXs0LSg2N8JRGSgTpcfzrcPmOWpCIe9qhuIBEy7KrF/7d1WlSArz8cYOigpCe8asnrmJ8yLj30ck7cWQl/0Vqq0ioolaBOE5jOUvecQK8mrwNi5QIDAQAB";

const normalizePublicKey = (keyBody: string) => {
  return keyBody.replace(/-----BEGIN PUBLIC KEY-----|-----END PUBLIC KEY-----|\s+/g, "");
};

const toPublicKeyPem = (keyBody: string) => {
  const normalizedKey = normalizePublicKey(keyBody);
  const keyLines = normalizedKey.match(/.{1,64}/g) ?? [];
  return `-----BEGIN PUBLIC KEY-----\n${keyLines.join("\n")}\n-----END PUBLIC KEY-----`;
};

const ALPAS_PUBLIC_KEY_PEM = toPublicKeyPem(ALPAS_PUBLIC_KEY_BODY);
const ALPAS_PUBLIC_KEY = forge.pki.publicKeyFromPem(ALPAS_PUBLIC_KEY_PEM);

export const hashPasswordForKlas = (password: string) => {
  return SHA256(password).toString();
};

export const encryptPasswordForAlpas = (password: string) => {
  // OAEP 테스트 시 서버 응답값이 없어 현재는 PKCS#1 v1.5를 기준으로 유지한다.
  const encryptedBytes = ALPAS_PUBLIC_KEY.encrypt(password, "RSAES-PKCS1-V1_5");
  return forge.util.encode64(encryptedBytes);
};
